import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { signOut } from "firebase/auth";
import React, { useEffect, useRef, useState } from "react";
import Cookies from "universal-cookie";
import "./App.css";
import { Auth } from "./components/Auth";
import { Chat } from "./components/Chat";
import { auth } from "./firebase-config.js";
import config from "./json/config.json";
library.add(fas, fab);
const { appConfig } = config;
const { chatRoles } = config;
const {
  appVersion,
  appVersionDate,
  appFooter,
  appFooterSymbol,
  appTitleName,
  bugReportLink,
  roomCodeLength,
  maxRecentRoomsAdmin,
  maxRecentRoomsVip,
  maxRecentRoomsDefault,
} = appConfig;
const { admins, vips } = chatRoles;
// Rollen ------------------------------------------
const userEmail = auth.currentUser?.email || null;
const isRoleAdmin = userEmail && admins.includes(userEmail);
const isRoleVip = userEmail && vips.includes(userEmail);

const randomEmoji =
  appFooterSymbol[Math.floor(Math.random() * appFooterSymbol.length)];
const cookies = new Cookies();

function App() {
  const [isAuth, setIsAuth] = useState(cookies.get("auth-token"));
  const [room, setRoom] = useState(null);
  const [recentRooms, setRecentRooms] = useState([]);
  const roomInputRef = useRef(null);

  useEffect(() => {
    // Raumverlauf laden
    const savedRecentRooms = cookies.get("recent-rooms");
    if (savedRecentRooms) {
      setRecentRooms(savedRecentRooms);
    }
  }, []);

  // Abmelden
  const signUserOut = async () => {
    await signOut(auth);
    cookies.remove("auth-token");
    setIsAuth(false);
    setRoom(null);
    document.title = appTitleName;
  };

  // Raum verlassen
  const leaveRoom = () => {
    setRoom(null);
    document.title = appTitleName;
  };

  // Raumverlauf speichern
  const addToRecentRooms = (roomName) => {
    if (roomName.trim() !== "") {
      setRecentRooms((prevRooms) => {
        if (!prevRooms.includes(roomName)) {
          let updatedRooms;
          if (isRoleAdmin) {
            updatedRooms = [roomName, ...prevRooms].slice(
              0,
              maxRecentRoomsAdmin
            );
          } else if (isRoleVip) {
            updatedRooms = [roomName, ...prevRooms].slice(0, maxRecentRoomsVip);
          } else {
            updatedRooms = [roomName, ...prevRooms].slice(
              0,
              maxRecentRoomsDefault
            );
          }
          cookies.set("recent-rooms", updatedRooms);
          return updatedRooms;
        }
        return prevRooms;
      });
    }
  };

  // Random Raum joinen
  const joinRandomRoom = () => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let randomRoomName = "";
    const charactersLength = characters.length;

    for (let i = 0; i < roomCodeLength; i++) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      randomRoomName += characters.charAt(randomIndex);
    }

    setRoom(randomRoomName);
    addToRecentRooms(randomRoomName);
  };
  // Wenn nicht angemeldet
  if (!isAuth) {
    return (
      <div>
        <Auth setIsAuth={setIsAuth} />
      </div>
    );
  }

  // Wenn angemeldet
  return (
    <>
      <header align="center">
        <footer footer align="center">
          <p>
            &copy; {appFooter} {randomEmoji} {appVersion} ({appVersionDate})
          </p>
        </footer>
        <div className="header-controls">
          <div className="action-buttons">
            <button className="leaveBtn" onClick={leaveRoom}>
              <FontAwesomeIcon icon={["fas", "arrow-left"]} /> Zurück zur Lobby
            </button>
            <button className="signOutBtn" onClick={signUserOut}>
              <FontAwesomeIcon icon={["fas", "sign-out-alt"]} /> Abmelden
            </button>
            <button
              className="bugReportBtn"
              onClick={() => window.open(bugReportLink, "_blank")}
            >
              <FontAwesomeIcon icon={["fab", "discord"]} /> Discord
            </button>
          </div>
        </div>
      </header>
      {room ? (
        <Chat
          room={room}
          onRoomJoin={(roomName) => addToRecentRooms(roomName)}
        />
      ) : (
        <body>
          <div className="room">
            <h1>LOBBY</h1>
            <p>
              HAUPTRAUM: <b>A</b>
            </p>
            <br></br>
            <form>
              <input
                ref={roomInputRef}
                placeholder="RAUMCODE EINGEBEN"
                required
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                  e.target.value = e.target.value.slice(0, roomCodeLength);
                  e.target.value = e.target.value.toUpperCase();
                }}
              />
              <button
                type="submit"
                onClick={() => {
                  const roomName = roomInputRef.current.value;
                  setRoom(roomName);
                  addToRecentRooms(roomName);
                }}
              >
                <FontAwesomeIcon icon={["fas", "sign-in-alt"]} /> BEITRETEN
              </button>
              <button type="submit" onClick={joinRandomRoom}>
                <FontAwesomeIcon icon={["fas", "dice"]} /> ZUFÄLLIG
              </button>
            </form>
            <div className="recent-rooms">
              <div className="verlauf">
                <br></br>
                <h2>GESPEICHERTE RÄUME</h2>
                <br></br>
                <button
                  onClick={() => {
                    cookies.remove("recent-rooms");
                    setRecentRooms([]);
                  }}
                >
                  {recentRooms.length === 0 ? (
                    "KEINE RÄUME"
                  ) : (
                    <>
                      <FontAwesomeIcon
                        icon={["fas", "trash"]}
                        className="deleteIcon"
                      />{" "}
                      LÖSCHE {recentRooms.length} /{" "}
                      {isRoleAdmin
                        ? maxRecentRoomsAdmin
                        : isRoleVip
                        ? maxRecentRoomsVip
                        : maxRecentRoomsDefault}{" "}
                      RÄUME
                    </>
                  )}
                </button>
                {recentRooms.map((roomName, index) => (
                  <p
                    key={index}
                    onClick={() => setRoom(roomName)}
                    className="room-link"
                  >
                    <span className="roomNameRecent">{roomName}</span>
                  </p>
                ))}
              </div>
            </div>
          </div>
        </body>
      )}
    </>
  );
}

export default App;
